export type RecaptchaAction =
  | 'lead_form_submit'
  | 'trade_in_search'
  | 'trade_in_form_submit'
  | 'validate_email'
  | 'newsletter_form_submit'
  | 'booking_search'
  | 'subscribe_form_submit';

export const getRecaptchaToken = (action: RecaptchaAction): Promise<string> =>
  new Promise((res) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.RECAPTCHA_TOKEN, { action }).then((token: string) => res(token));
    });
  });
